import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
import { RadioButton, Button } from '../../genericComponents'
import CreditCardCheckoutForm from './CreditCardCheckoutForm'
import paypalIcon from '../../../assets/images/sprites/PayPal-logo.png';
import { toast } from 'react-toastify'
import axios from 'axios'
import { useHistory } from "react-router-dom";
import { paymentApiURL } from '../../../helpers/initializeServices';


export default function PaymentMethodComponent({ cancelPaymentClickHandler, selectedMembership, userEmail, stripeSubscription}) {
  const [showCheckout, setShowCheckout] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')

  let history = useHistory()

  const handlerRadioChange = (e) => {
    setSelectedOption(e.target.value)
    setShowCheckout(e.target.value !== 'paypal')
  }

  const paypalCreateOrder = async () => {
    let response = await axios.post(`${paymentApiURL}/paypalPaymentProcesing`, {
      code: selectedMembership.type,
      email: userEmail
    })
    const { data } = response;
    return data.orderID // Use the key sent by your server's response, ex. 'id' or 'token'
  }

  const paypalApprove = async (data, actions) => {
    toast.info('Your payment is being processed')
    history.push(`/membership`)
  }
  const paypalCancel = async (data) => {
    console.log("data=>", data)
  }

  // useEffect(() => {
  //   if(selectedMembership.payment_interval>0){
  //     setSelectedOption('cc')
  //   }
  // }, [selectedMembership])

  return (
    <Container>
      <Title>Payment Method</Title>
      <ContentContainer>
        <PaymentMethodContainer>
          <RadioButtonContainer value={'paypal'} selected={'paypal' === selectedOption}>
            <RadioButtonComponent
              label={'PayPal'}
              value={'paypal'}
              checked={selectedOption == 'paypal'}
              onChange={handlerRadioChange}
            />
          </RadioButtonContainer>
          <ImageContainer >
            <img src={paypalIcon} width="140" alt="" />
          </ImageContainer>
          {(selectedOption === 'paypal') && (
            <PaypalButtonContainer>
              <PayPalButtons createOrder={paypalCreateOrder}
                onApprove={paypalApprove}
                onCancel={paypalCancel}
                style={{ shape: "pill", label: "pay", height: 40, layout: "horizontal" }}
              />
            </PaypalButtonContainer>
          )}
        </PaymentMethodContainer>
        <PaymentMethodContainer>
          <RadioButtonContainer value={'cc'} selected={'cc' === selectedOption}>
            <RadioButtonComponent
              label={'Credit or Debit Card'}
              value={'cc'}
              checked={selectedOption === 'cc'}
              onChange={handlerRadioChange}
            />
          </RadioButtonContainer>
        </PaymentMethodContainer>
        <CreditCardCheckoutForm
          membership={selectedMembership}
          setShowCheckout={setShowCheckout}
          showCheckout={showCheckout}
          cancelClick={cancelPaymentClickHandler}
          stripeSubscription={stripeSubscription}
        />
      </ContentContainer >
    </Container>
  );
}


const Container = styled.div`
  width: 100%;
`;

const ContentContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
  border-radius: 15px;
  padding:5px 30px;
  background-color: ${props => props.theme.color.softYellow};
`;

const PaymentMethodContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.color.darkBlue};
  padding: 10px;
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content:space-between;
  
`;

const ImageContainer = styled.div`
  display:flex;
  justify-content:flex-end;
  width: 50%;
  
`;
const Title = styled.div`
  margin-bottom: 10px;
  padding: 10px;
  font-weight: bold;
  font-size: 150%;  
`;

const PaypalButtonContainer = styled.div`
  margin: 0 auto;
  width: 40%;
  height: 40px;
`;

const RadioButtonComponent = styled(RadioButton)`
  font-size:24px;
`;
const RadioButtonContainer = styled.div`
  width: 50%;
  font-weight: ${p => p.selected ? 'bold' : 'normal'};
`;